import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import { List, ListItem } from "material-ui/List";
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import DownloadFile from 'material-ui/svg-icons/file/cloud-download';
import Divider from 'material-ui/Divider';
import icoXLS from "../../../../../../assets/img/ico-xls.png";

export default class ModalDescargaPartesXLS extends React.Component<ModalDescargaPartesXLSProps, any> {

    render() {
        const { titulo, totalRegistros } = this.props;

        return (
            <div>
                <Modal show={this.props.verModalXLS} onHide={this.props.closeModalXLS}>
                    <Modal.Header>
                        <Modal.Title>Exportar XLS - {titulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Existen {this.calcularCantidadArchivos()} reportes para exportar para los {totalRegistros} registros encontradas con el filtro de busqueda.
                        Selecciona el reporte que deseas exportar, para así iniciar la descarga.
                        <List>
                            <Subheader>Listado de reportes para descargar</Subheader>
                            {this.listaReportesXLS()}
                        </List>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-secondary"} onClick={this.props.closeModalXLS}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    listaReportesXLS() {
        const { cantidadDescargaReporte } = this.props;
        const cantidadArchivos = this.calcularCantidadArchivos();
        const listaItems = [];
        for (let descarga = 0; descarga < cantidadArchivos; descarga++) {
            listaItems.push(
                <div key={descarga}>
                    <Divider />
                    <ListItem
                        primaryText={`Descargar reporte # ${descarga}`}
                        secondaryText={`Informe del registro ${this.calcularInicio(descarga)} al registro ${this.calcularFin(descarga)}`}
                        leftAvatar={<Avatar src={icoXLS} size={40} />}
                        rightIcon={<DownloadFile />}
                        onClick={this.props.generarXLS.bind(this, descarga, cantidadDescargaReporte)}
                    />
                </div>
            );
        }
        return <List>{listaItems}</List>;
    }

    calcularCantidadArchivos = () => {
        const { totalRegistros, cantidadDescargaReporte } = this.props;
        return Math.ceil(totalRegistros / cantidadDescargaReporte);
    }

    calcularInicio = (iteracion: number) => {
        const { cantidadDescargaReporte } = this.props;
        return 1 + (iteracion * cantidadDescargaReporte);
    }

    calcularFin = (iteracion: number) => {
        const { totalRegistros, cantidadDescargaReporte } = this.props;
        return Math.min((iteracion + 1) * cantidadDescargaReporte, totalRegistros);
    }
}

interface ModalDescargaPartesXLSProps {
    titulo: string,
    totalRegistros: number,
    cantidadDescargaReporte: number,
    verModalXLS: boolean,
    closeModalXLS: () => void;
    generarXLS: (numeroReporte: number, cantidadRegistros: number) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/ModalDescargaPartesXLS.tsx